module.exports = __webpack_public_path__ + "img/bell-school-slash.4215f8c3.svg";